import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  NgZone
} from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from './app.constants';
import { ITSUserData} from './models/cm-model';
import { UserData } from './shared/models/user.model';
import { CapacityModelService } from './services/CapacityModel-Service';
import { getSelectedFiscalYear } from './services/fiscal-year.helper';


@Component({
  selector: 'app-header1',
  templateUrl: './app-header.html',
})
export class AppHeaderComponent1 {
  @HostBinding('class.header') get isHeader() { return true; }
  @HostBinding('class.is-personalizable') get isPersonalizable() { return true; }
  LoggedInUserName: string = '';
  //userData = new UserData();
  headfiscalyear:any;
  applicationaccess:any;
  showMenu: boolean = false;
  itsuserData = new ITSUserData();

  constructor(private ngZone: NgZone, private router: Router,private cdRef : ChangeDetectorRef) { }

  ngOnInit() {
   
  }
  ngAfterViewInit(): void {

    // Single source of truth for the selected fiscal year. It seeds the default
    // ("CY" + current year) on first use, so the dropdown and everything gated
    // on the fiscal year always agree regardless of component init order.
    this.headfiscalyear = getSelectedFiscalYear();
    this.cdRef.detectChanges();
    this.itsuserData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.itsuserData != null && this.itsuserData != undefined) {
      document.getElementById("lblEmployeeName")!.innerText = this.itsuserData.Name;    
    }
  }

  onOptionsSelected(){

    localStorage.setItem("fiscalyear", this.headfiscalyear );
    // The fiscal year is global context: it drives every API call, which grid
    // columns are rendered and which menu areas exist. Reloading the app
    // (equivalent to the browser refresh the app already supports on startup)
    // guarantees the new year is applied everywhere, including the application
    // menu, which is built once per app load.
    window.location.hash = '/' + Constants.defaultRoute;
    window.location.reload();
  }

  RedirectToHome() {
    this.ngZone.run(() => this.router.navigate([Constants.defaultRoute])).then();
  }
}
